import { z } from 'zod'
import { useZodForm } from '@minetrace/ui/forms'

export const step2RolesSchema = z.object({
  roleIds: z.array(z.string()).min(1, 'personas.nuevo.zod.rolesRequired'),
  licenseNumber: z.string().optional(),
  licenseCategory: z.string().optional(),
  licenseExpiryDate: z.string().optional(),
  colegiatureCode: z.string().optional(),
  colegiatureExpiryDate: z.string().optional(),
})

export type Step2RolesFormValues = z.infer<typeof step2RolesSchema>

const defaultValues: Step2RolesFormValues = {
  roleIds: [],
  licenseNumber: '',
  licenseCategory: '',
  licenseExpiryDate: '',
  colegiatureCode: '',
  colegiatureExpiryDate: '',
}

export const useStep2RolesForm = (props?: { defaultValues?: Step2RolesFormValues }) =>
  useZodForm<Step2RolesFormValues>({
    validationSchema: step2RolesSchema,
    defaultValues: { ...defaultValues, ...props?.defaultValues },
  })
